import React, { Component } from 'react';
import "./App.css";

class AboutContainerCenter extends Component {
    render() {
        return (
            <div >
                <br />
                <p style={{"textAlign": "center", "color": "white", "font-family": "Comfortaa"}}>{this.props.text}</p>       
                <br />
            </div>
        )
    }
};

class AboutContainerLeft extends Component {
    render() {
        return (
            <div>
                <p style={{"textAlign": "left", "color": "white", "font-family": "Fuzzy Bubbles"}}>{this.props.text}</p>       
            </div>
        )
    }
};

class AboutContainerRight extends Component {
    render() {
        return (
            <div>
                <p style={{"textAlign": "right", "color": "white", "font-family": "Fuzzy Bubbles"}}>{this.props.text}</p>       
            </div>
        )
    }
};

class ContactContainer extends Component {
    render() {
        return (
            <div>
                <p style={{"color": "white", "textAlign": "center", "font-family": "Fuzzy Bubbles"}}>{this.props.text}</p>
                {/* <br /> */}
            </div>
        )
    }
}

export { AboutContainerCenter, AboutContainerLeft, AboutContainerRight, ContactContainer } ;